import { useCallback } from "react";
import { Box } from "@mui/material";
import { toast } from "react-toastify";
import DevModeOptions from "./DevModeOptions";
import { useDevMode } from "../../context/DevModeContext";
import { useSecretCode } from "../../hooks/useSecretCode";

const UNLOCK_CODE = "hims1111";

export default function DevModeSection() {
  const { devMode, enable, disable } = useDevMode();

  const unlock = useCallback(() => {
    enable();
    toast.success("개발자 모드가 활성화되었습니다.");
  }, [enable]);

  useSecretCode(UNLOCK_CODE, unlock);

  if (!devMode) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "flex-end" }}>
      <DevModeOptions onExit={disable} />
    </Box>
  );
}
